import React, { Component } from "react";
import VerificarDocumentoTitularComponent from "../../../components/personaReferencia/verificarDocumentoTitular/VerificarDocumentoTitularComponent";
import { verificarDocumentoTitularStore } from "./VerificarDocumentoTitular.store";
import { verificarDocumentoTitularDispatcher } from "./VerificarDocumentoTitular.dispatcher";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import ModalFrame from "../../../../toolkit/modalFrame";

interface Props {
  idMembresiaSocio: number;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

interface State {}

@ReduxConnect(
  verificarDocumentoTitularStore,
  verificarDocumentoTitularDispatcher
)
export default class VerificarDocumentoTitularModal extends Component<
  Props,
  State
> {
  state = {};

  render() {
    return (
      <ModalFrame
        title="Verificar Documento del Titular"
        isOpen={this.props.isOpen}
        toggle={this.props.onClose}
        size="xl"
      >
        <VerificarDocumentoTitularComponent {...(this.props as any)} />
      </ModalFrame>
    );
  }
}
